/* eslint-disable no-undef */
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_ADMIN_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_ADMIN_SUPABASE_ANON_KEY;

export const adminSupabase = createClient(supabaseUrl, supabaseKey);
